function sortData (data, prop) {
    var myData = data
    .sort((a, b) => {
      
      if (a[prop] < b[prop]) {
        return -1;
      }
      if (a[prop] > b[prop]) {
        return 1;
      }
      return 0;
    })

    return myData;
}


const HandleData = { sortData };
export default HandleData;


// WEBPACK FOOTER //
// ./src/utils/HandleData.js